export default {
      id: "trash-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#trash",
      toString: function () {
        return this.url;
      }
    }